export const TASK_MODE = Object.freeze({
  REVIEW: 'REVIEW',
  EDIT: 'EDIT',
  META_REVIEW: 'META_REVIEW',
  REJECTED: 'REJECTED'
});
export type TaskModeT = (typeof TASK_MODE)[keyof typeof TASK_MODE];